import options from './edit-navbar.directive';

export default {
    selector: 'dtEditNavbar',
    options
};



// WEBPACK FOOTER //
// ./app/common/edit-navbar/index.js